import { produce } from "immer";
import * as tasksActions from "./tasksActions";
import { format } from "date-fns";
import { getDateByTimestamp } from "utils/helpers/timestamp";
import { parseDateOnly } from "utils/helpers/dates";
import { dateFormat } from "utils/helpers/useLocaleFormat";

export const initialSelectedObj = {
  name: "",
  description: "",
  reminderdate: "",
  reminder_email: 0,
  priority: "normal",
  alarm: 1,
  status: "inprogress",
  location: "",
  percent: 0,
  startdate: "",
  enddate: ""
};

const initialState = {
  isListFetching: false,
  isSingleFetching: false,
  isSubmitting: false,
  errorMessage: { list: null, single: null },
  list: { data: [], total: 0 },
  activeTaskId: null,
  params: { offset: 0, limit: 20, order: null, order_type: null },
  selected: initialSelectedObj,
  reminderModal: {}
};

const reducer = produce((draft, action) => {
  switch (action.type) {
    case tasksActions.SET_SELECTED: {
      draft.selected = { ...action.payload };
      break;
    }
    case tasksActions.RESET_SELECTED: {
      draft.activeTaskId = null;
      draft.selected = { ...initialSelectedObj };
      break;
    }
    case tasksActions.SET_PARAMS: {
      draft.params = { ...action.payload };
      break;
    }
    case tasksActions.FETCH_TASKS: {
      draft.isListFetching = true;
      draft.errorMessage.list = null;
      break;
    }
    case tasksActions.FETCH_TASKS_SUCCESS: {
      draft.list.data = action.payload.data;
      draft.list.total = action.payload.total;
      draft.isListFetching = false;
      break;
    }
    case tasksActions.FETCH_TASKS_FAILED: {
      draft.errorMessage.list = action.payload.errorText;
      draft.isListFetching = false;
      break;
    }
    case tasksActions.FETCH_TASK: {
      draft.activeTaskId = action.payload;
      draft.isSingleFetching = true;
      draft.errorMessage.single = null;
      break;
    }
    case tasksActions.FETCH_TASK_SUCCESS: {
      let payload = action.payload;
      payload["reminderdate"] = "";
      payload["startdate"] = payload["startdate"] || "";
      payload["enddate"] = payload["enddate"] || "";
      if (payload?.alarms?.length) {
        const showReminderdate = new Date(
          Object.values(payload?.alarms).filter(
            item => item.action === "DISPLAY"
          )?.[0]?.trigger_date
        );
        payload["reminderdate"] = showReminderdate;
        payload["showReminderdate"] = getDateByTimestamp(
          showReminderdate.valueOf() / 1000,
          false,
          true
        );
      }
      if (payload["startdate"]) {
        // Task dates have no time: shown as the day itself
        payload["startdate"] = parseDateOnly(payload["startdate"]);
        payload["showStartdate"] = format(payload["startdate"], dateFormat());
      }
      if (payload["enddate"]) {
        // Task dates have no time: shown as the day itself
        payload["enddate"] = parseDateOnly(payload["enddate"]);
        payload["showEnddate"] = format(payload["enddate"], dateFormat());
      }
      if (payload["description"]) {
        const description = payload["description"].split(
          ' class="message-link" style="display:none" href="#"></a>'
        );
        if (description.length > 1) {
          payload["description"] = description[1];
          payload["messageInfo"] = description[0].split('"')[1];
        }
      }

      draft.selected = payload;
      draft.isSingleFetching = false;
      break;
    }
    case tasksActions.FETCH_TASK_FAILED: {
      draft.errorMessage.single = action.payload.errorText;
      draft.isSingleFetching = false;
      break;
    }
    case tasksActions.SUBMIT_TASK: {
      draft.errorMessage.single = null;
      draft.isSubmitting = true;
      break;
    }
    case tasksActions.REMIND_TASK: {
      if (action.payload?.id) {
        let temp = { ...draft.reminderModal };
        temp[action.payload?.id] = action.payload;
        draft.reminderModal = { ...temp };
      }
      break;
    }
    case tasksActions.SUBMIT_TASK_SUCCESS: {
      let payload = action.payload;
      payload["reminderdate"] = "";
      payload["startdate"] = payload["startdate"] || "";
      payload["enddate"] = payload["enddate"] || "";
      if (payload?.alarms?.length) {
        const showReminderdate = new Date(
          Object.values(payload?.alarms).filter(
            item => item.action === "DISPLAY"
          )?.[0]?.trigger_date
        );
        payload["reminderdate"] = showReminderdate;
        payload["showReminderdate"] = getDateByTimestamp(
          showReminderdate.valueOf() / 1000,
          false,
          true
        );
      }
      if (payload["startdate"]) {
        // Task dates have no time: shown as the day itself
        payload["startdate"] = parseDateOnly(payload["startdate"]);
        payload["showStartdate"] = format(payload["startdate"], dateFormat());
      }
      if (payload["enddate"]) {
        // Task dates have no time: shown as the day itself
        payload["enddate"] = parseDateOnly(payload["enddate"]);
        payload["showEnddate"] = format(payload["enddate"], dateFormat());
      }
      if (payload["description"]) {
        const description = payload["description"].split(
          ' class="message-link" style="display:none" href="#"></a>'
        );
        if (description.length > 1) {
          payload["description"] = description[1];
          payload["messageInfo"] = description[0].split('"')[1];
        }
      }

      draft.selected = payload;
      draft.isSubmitting = false;
      draft.reminderModal = null;
      break;
    }
    case tasksActions.SUBMIT_TASK_FAILED: {
      draft.errorMessage.single = action.payload.errorText;
      draft.isSubmitting = false;
      break;
    }

    default:
      return draft;
  }
}, initialState);

export default reducer;
